import cx from 'classnames';
import React, { createElement } from 'react';
import { withNativeProps } from '../../utils/native-props';
var classPrefix = 'nib-nav-bar-button';
export var NavBarActionButton = function NavBarActionButton(props) {
  var _cx;

  var _a;

  var icon = props.icon,
      text = props.text;
  var clickable = (_a = props.clickable) !== null && _a !== void 0 ? _a : Boolean(props.onClick);
  var content = /*#__PURE__*/React.createElement(React.Fragment, null, icon && /*#__PURE__*/React.createElement("div", {
    className: cx(classPrefix + "-icon", props.iconClassName),
    style: props.iconStyle
  }, icon), text && /*#__PURE__*/React.createElement("div", {
    className: cx(classPrefix + "-text", props.textClassName),
    style: props.textStyle
  }, text));
  return withNativeProps(props, /*#__PURE__*/createElement(clickable ? 'a' : 'div', {
    className: cx(classPrefix, (_cx = {}, _cx['nib-plain-anchor'] = clickable, _cx)),
    onClick: props.onClick
  }, content));
};